import { useSearchParams } from 'react-router-dom';
import { StandingAccessReportEntitlementFilterInput } from '@api/gql/graphql';
import {
  ASSESSMENT_REPORT_BOOLEAN_FILTER_OPTION,
  ASSESSMENT_REPORT_PERMISSIONS_FILTER,
  ASSESSMENT_REPORT_RESOURCES_FILTER,
  ASSESSMENT_REPORT_RISK_SCORE_FILTER,
  ASSESSMENT_REPORT_REVOKED_FILTER,
  ASSESSMENT_REPORT_IN_ACCESS_FLOW_FILTER,
  ASSESSMENT_REPORT_LINKED_ELEMENTS_FILTER,
  ASSESSMENT_REPORT_TIER_FILTER,
} from '@StandingAccess/types';

export function useReportFilters(): StandingAccessReportEntitlementFilterInput {
  const [searchParams] = useSearchParams();

  const getBooleanParam = (param: string | null): boolean | undefined => {
    if (!param) return undefined;

    return param === ASSESSMENT_REPORT_BOOLEAN_FILTER_OPTION.yes
      ? true
      : param === ASSESSMENT_REPORT_BOOLEAN_FILTER_OPTION.no
        ? false
        : undefined;
  };

  return {
    tier: searchParams.getAll(ASSESSMENT_REPORT_TIER_FILTER.param),
    resource: searchParams.getAll(ASSESSMENT_REPORT_RESOURCES_FILTER.param),
    permission: searchParams.getAll(ASSESSMENT_REPORT_PERMISSIONS_FILTER.param),
    linkedElement: searchParams.getAll(ASSESSMENT_REPORT_LINKED_ELEMENTS_FILTER.param),
    riskScore: searchParams.getAll(ASSESSMENT_REPORT_RISK_SCORE_FILTER.param).map(Number),
    inAccessFlow: getBooleanParam(searchParams.get(ASSESSMENT_REPORT_IN_ACCESS_FLOW_FILTER.param)),
    revoked: getBooleanParam(searchParams.get(ASSESSMENT_REPORT_REVOKED_FILTER.param)),
  };
}
